module.exports = __webpack_public_path__ + "img/bolter-logo.4892c337.svg";